import { generateTranslations } from '../../i18n/translation';

const namespace = 'calendarcommon';

const translations = generateTranslations(namespace, {
  timelineHeaderSpring: {
    nb: 'Vår',
    en: 'Spring',
  },
  timelineHeaderFall: {
    nb: 'Høst',
    en: 'Fall',
  },
  timelineheaderActivities: {
    nb: 'Praksisaktiviteter',
    en: 'Activities',
  },
  downloadCsv: {
    nb: 'Last ned kalender (.csv)',
    en: 'Download calendar (.csv)',
  },
  downloadCsvDialogTitle: {
    nb: 'Last ned kalenderdata som en .csv-fil',
    en: 'Download calendar data as a .csv file',
  },
  downloadCsvDialogSubtitle: {
    nb: 'Velg hvilken periode du vil hente data fra. Valgt studieår i kalenderen er satt som utgangspunkt.',
    en: 'Choose the period you wish to fetch data from. The currently selected calendar year is the default value.',
  },
  downloadCsvFromDate: {
    nb: 'Last ned data fra dato:',
    en: 'Download data from date:',
  },
  downloadCsvToDate: {
    nb: 'Last ned data til dato:',
    en: 'Download data until date:',
  },
  selectActivitystatusDropdown: {
    nb: 'Velg visningstype',
    en: 'Select view',
  },
  selectActivitystatusDropdownUnfiltered: {
    nb: 'Vis alle emner',
    en: 'Show all subjects',
  },
  selectActivitystatusDropdownAllActivities: {
    nb: 'Alle praksisaktiviteter',
    en: 'All activities',
  },
  selectActivitystatusDropdownActivitiesNotShared: {
    nb: 'Udelte aktiviteter',
    en: 'Activities not shared',
  },
  selectActivitystatusDropdownActivitiesMissingNeed: {
    nb: 'Manglende behov',
    en: 'Missing need',
  },
  selectActivitystatusDropdownActivitiesMissingCapacity: {
    nb: 'Manglende kapasitet',
    en: 'Missing capacity',
  },
  selectActivitystatusDropdownActivitiesFilledCapacity: {
    nb: 'Dekket kapasitet',
    en: 'Filled capacity',
  },
  searchbarSearchinputPlaceholder: {
    nb: 'Søk etter praksistype eller emne...',
    en: 'Search for practice types or subjects...',
  },
  showDays: {
    nb: 'Vis dager',
    en: 'Show days',
  },
  showWeeks: {
    nb: 'Vis uker',
    en: 'Show weeks',
  },
});

export default translations;
